'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cvcFormatter = exports.expiryFormatter = exports.numberFormatter = exports.getCardType = undefined;

var _lodash = require('lodash');

var _stringUtil = require('../../../../common/utils/stringUtil');

var _stripeService = require('./stripeService');

var DATE_SEPARATOR = ' / ';

var getCardType = exports.getCardType = (0, _lodash.throttle)(function (number) {
    if ((0, _stripeService.getStripe)()) return (0, _stripeService.getStripe)().card.cardType(number).toLowerCase();
}, 200);

var filterRegex = /[^0-9\•]/g;

var numberFormatter = exports.numberFormatter = function numberFormatter(number) {
    return (0, _stringUtil.chunkString)(number.replace(filterRegex, '').substr(0, 16), 4).join(' ');
};

var endsInSeparator = function endsInSeparator(expiry, dateParts) {
    return (expiry.indexOf('/') === 2 || expiry.indexOf(DATE_SEPARATOR) === 2) && dateParts.length === 1;
};

var expiryFormatter = exports.expiryFormatter = function expiryFormatter(expiry) {
    var dateParts = (0, _stringUtil.chunkString)(expiry.replace(filterRegex, '').substr(0, 4), 2);
    return endsInSeparator(expiry, dateParts) ? dateParts[0] + DATE_SEPARATOR : dateParts.join(DATE_SEPARATOR);
};

var cvcFormatter = exports.cvcFormatter = function cvcFormatter(cvc) {
    return cvc.replace(filterRegex, '').substr(0, 4);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/creditCard/creditCardFormatters.js
// module id = 1775
// module chunks = 0